/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GeneratorRepresentation
 */
export interface GeneratorRepresentation {
    /**
     * 
     * @type {string}
     * @memberof GeneratorRepresentation
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof GeneratorRepresentation
     */
    parkKey?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneratorRepresentation
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GeneratorRepresentation
     */
    model?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneratorRepresentation
     */
    serialNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof GeneratorRepresentation
     */
    power?: number;
    /**
     * 
     * @type {number}
     * @memberof GeneratorRepresentation
     */
    hubHeight?: number;
    /**
     * 
     * @type {string}
     * @memberof GeneratorRepresentation
     */
    manufacturer?: string;
    /**
     * 
     * @type {number}
     * @memberof GeneratorRepresentation
     */
    installationDate?: number;
    /**
     * 
     * @type {object}
     * @memberof GeneratorRepresentation
     */
    type?: GeneratorRepresentationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GeneratorRepresentation
     */
    typeName?: string;
    /**
     * 
     * @type {number}
     * @memberof GeneratorRepresentation
     */
    longitude?: number;
    /**
     * 
     * @type {number}
     * @memberof GeneratorRepresentation
     */
    latitude?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeneratorRepresentation
     */
    active?: boolean;
}


/**
 * @export
 */
export const GeneratorRepresentationTypeEnum = {
    Wind: 'wind',
    Solar: 'solar'
} as const;
export type GeneratorRepresentationTypeEnum = typeof GeneratorRepresentationTypeEnum[keyof typeof GeneratorRepresentationTypeEnum];


/**
 * Check if a given object implements the GeneratorRepresentation interface.
 */
export function instanceOfGeneratorRepresentation(value: object): value is GeneratorRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GeneratorRepresentationFromJSON(json: any): GeneratorRepresentation {
    return GeneratorRepresentationFromJSONTyped(json, false);
}

export function GeneratorRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeneratorRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'parkKey': json['parkKey'] == null ? undefined : json['parkKey'],
        'name': json['name'],
        'model': json['model'] == null ? undefined : json['model'],
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        'power': json['power'] == null ? undefined : json['power'],
        'hubHeight': json['hubHeight'] == null ? undefined : json['hubHeight'],
        'manufacturer': json['manufacturer'] == null ? undefined : json['manufacturer'],
        'installationDate': json['installationDate'] == null ? undefined : json['installationDate'],
        'type': json['type'] == null ? undefined : json['type'],
        'typeName': json['typeName'] == null ? undefined : json['typeName'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function GeneratorRepresentationToJSON(json: any): GeneratorRepresentation {
    return GeneratorRepresentationToJSONTyped(json, false);
}

export function GeneratorRepresentationToJSONTyped(value?: GeneratorRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'parkKey': value['parkKey'],
        'name': value['name'],
        'model': value['model'],
        'serialNumber': value['serialNumber'],
        'power': value['power'],
        'hubHeight': value['hubHeight'],
        'manufacturer': value['manufacturer'],
        'installationDate': value['installationDate'],
        'type': value['type'],
        'typeName': value['typeName'],
        'longitude': value['longitude'],
        'latitude': value['latitude'],
        'active': value['active'],
    };
}

